import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import classNames from "classnames";
import { defaultPropertiesOverride } from "../../constants";
import { getClassName, getTypeClassName, getRowHeaderClassName, getRenderer } from "../../utils";
export var TableBody = function TableBody(_ref) {
  var rows = _ref.rows,
      getColumnProps = _ref.getColumnProps,
      getCellProps = _ref.getCellProps,
      getRowProps = _ref.getRowProps,
      prepareRow = _ref.prepareRow;

  var getTableBodyCell = function getTableBodyCell(cell) {
    var _cell$value, _cell$value$props;

    var column = cell.column;
    var type = column.type,
        rowHeader = column.rowHeader,
        className = column.className,
        style = column.style,
        formatCell = column.formatCell,
        renderSelectionCell = column.renderSelectionCell;
    var renderer = formatCell || getRenderer(type);
    var cellComponent = cell.render(renderer);
    var isHeaderCell = cell === null || cell === void 0 ? void 0 : (_cell$value = cell.value) === null || _cell$value === void 0 ? void 0 : (_cell$value$props = _cell$value.props) === null || _cell$value$props === void 0 ? void 0 : _cell$value$props.header;
    var Element = rowHeader || isHeaderCell ? "th" : "td";
    var cellProps = cell.getCellProps([defaultPropertiesOverride, rowHeader || isHeaderCell ? {
      scope: "row"
    } : {}, (getColumnProps === null || getColumnProps === void 0 ? void 0 : getColumnProps(column)) || {}, (getCellProps === null || getCellProps === void 0 ? void 0 : getCellProps(cell)) || {}]);
    return /*#__PURE__*/React.createElement(Element, _extends({}, cellProps, {
      style: style,
      className: classNames(getClassName({
        descendantName: "cell",
        modifiers: "body"
      }), getTypeClassName(type), rowHeader && getRowHeaderClassName(), className)
    }), renderSelectionCell ? cell.render(renderSelectionCell(cellComponent)) : cellComponent);
  };

  var getBodyRow = function getBodyRow(row) {
    prepareRow(row);
    var rowProps = row.getRowProps([defaultPropertiesOverride, (getRowProps === null || getRowProps === void 0 ? void 0 : getRowProps(row)) || {}]);
    var rowClassName = getClassName({
      className: (rowProps === null || rowProps === void 0 ? void 0 : rowProps.className) || "",
      descendantName: "row",
      modifiers: classNames("body", row.isSelected ? "selected" : null)
    });
    return /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
      className: rowClassName
    }), row.cells.map(getTableBodyCell));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, rows.map(getBodyRow));
};